import { z } from 'zod';
import { PopulatedUserSchema } from '../../entities/user/user.schema';
/**
 * OrgFunction Member Schema
 *
 * A derived member of a OrgFunction: a populated user reference plus an `isLead`
 * flag marking the Funktionsleiter. Membership is never stored — it is derived
 * by the membership module from the user-side links (mainRole / secondaryRoles),
 * deduped by user id. The lead is the responsible person, not a member: a
 * lead-only user is absent from this list.
 */ export const OrgFunctionMemberSchema = PopulatedUserSchema.extend({
    // true when this user is the Funktionsleiter — only ever set on a lead who is
    // also a member through mainRole/secondaryRoles
    isLead: z.boolean()
});
/**
 * List OrgFunction Members Request Schema
 * GET /api/v2/orgFunction/:id/members
 */ export const ListOrgFunctionMembersRequestSchema = z.object({});
/**
 * List OrgFunction Members Response Schema
 * GET /api/v2/orgFunction/:id/members
 */ export const ListOrgFunctionMembersResponseSchema = z.object({
    data: z.array(OrgFunctionMemberSchema)
});

//# sourceMappingURL=list-org-function-members.schema.js.map